import { css } from 'linaria';
import { styled } from 'linaria/react';

export const CityPickerRoot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;

  button {
    align-items: flex-end;
    white-space: nowrap;

    & > div {
      display: flex;
      flex-direction: column;
      align-items: baseline;
    }
  }

  @media (--only-mobile) {
    padding-left: var(--space-150);
    button {
      transform: translateY(1px);
    }
  }
`;

export const cityPickerLabel = css`
  transform: translateY(-1px);
`;

export const popoverClassName = css`
  box-sizing: content-box;
`;

export const hoveredText = css`
  display: block;
  max-width: 190px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const hover = css`
  &:hover {
    background-color: initial !important;
    box-shadow: initial !important;

    .${hoveredText} {
      color: var(--brand-dark);
    }

    path {
      --i-color: var(--brand-dark);
    }
  }
`;

export const actionButton = css`
  width: 100%;
`;
